module.exports = __webpack_public_path__ + "src/img/index_menu/3.png?0ec5921996ae51ec59db3e67a3b47231";


//////////////////
// WEBPACK FOOTER
// ./src/img/index_menu/3.png
// module id = 176
// module chunks = 0